import { formatGermanDate } from "./Utils";

export const DateTag = ({ date }: { date?: string }) => <span>{formatGermanDate(date)}</span>;
